module.exports = {"illu_01":"illu_de_01.png","illu_02":"illu_de_02.png","illu_03":"illu_de_03.png","illu_04":"illu_de_04.png","illu_05":"illu_de_05.png"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/i18n/lang/de/jumbotron.json
// module id = irPI
// module chunks = 1